export function importIntlDisplayNamesLocaleData(locale: string) {
  switch (locale) {
    case 'de':
      return import(
        '@formatjs/intl-displaynames/locale-data/de' /* webpackChunkName: 'intl-displaynames-locale-data-de' */
      );
    case 'ja':
      return import(
        '@formatjs/intl-displaynames/locale-data/ja' /* webpackChunkName: 'intl-displaynames-locale-data-ja' */
      );
    case 'es':
      return import(
        '@formatjs/intl-displaynames/locale-data/es' /* webpackChunkName: 'intl-displaynames-locale-data-es' */
      );
    case 'es-mx':
      return import(
        '@formatjs/intl-displaynames/locale-data/es-MX' /* webpackChunkName: 'intl-displaynames-locale-data-es-MX' */
      );
    case 'id':
      return import(
        '@formatjs/intl-displaynames/locale-data/id' /* webpackChunkName: 'intl-displaynames-locale-data-id' */
      );
    case 'ko':
      return import(
        '@formatjs/intl-displaynames/locale-data/ko' /* webpackChunkName: 'intl-displaynames-locale-data-ko' */
      );
    case 'ms':
      return import(
        '@formatjs/intl-displaynames/locale-data/ms' /* webpackChunkName: 'intl-displaynames-locale-data-ms' */
      );
    case 'ru':
      return import(
        '@formatjs/intl-displaynames/locale-data/ru' /* webpackChunkName: 'intl-displaynames-locale-data-ru' */
      );
    case 'th':
      return import(
        '@formatjs/intl-displaynames/locale-data/th' /* webpackChunkName: 'intl-displaynames-locale-data-th' */
      );
    case 'tr':
      return import(
        '@formatjs/intl-displaynames/locale-data/tr' /* webpackChunkName: 'intl-displaynames-locale-data-tr' */
      );
    case 'uk':
      return import(
        '@formatjs/intl-displaynames/locale-data/uk' /* webpackChunkName: 'intl-displaynames-locale-data-uk' */
      );
    case 'vi':
      return import(
        '@formatjs/intl-displaynames/locale-data/vi' /* webpackChunkName: 'intl-displaynames-locale-data-vi' */
      );
    case 'da':
      return import(
        '@formatjs/intl-displaynames/locale-data/da' /* webpackChunkName: 'intl-displaynames-locale-data-da' */
      );
    case 'fr':
      return import(
        '@formatjs/intl-displaynames/locale-data/fr' /* webpackChunkName: 'intl-displaynames-locale-data-fr' */
      );
    case 'it':
      return import(
        '@formatjs/intl-displaynames/locale-data/it' /* webpackChunkName: 'intl-displaynames-locale-data-it' */
      );
    case 'nl':
      return import(
        '@formatjs/intl-displaynames/locale-data/nl' /* webpackChunkName: 'intl-displaynames-locale-data-nl' */
      );
    case 'pl':
      return import(
        '@formatjs/intl-displaynames/locale-data/pl' /* webpackChunkName: 'intl-displaynames-locale-data-pl' */
      );
    case 'pt':
    case 'pt-br':
      return import(
        '@formatjs/intl-displaynames/locale-data/pt' /* webpackChunkName: 'intl-displaynames-locale-data-pt' */
      );
    case 'sv':
      return import(
        '@formatjs/intl-displaynames/locale-data/sv' /* webpackChunkName: 'intl-displaynames-locale-data-sv' */
      );
    case 'fi':
      return import(
        '@formatjs/intl-displaynames/locale-data/fi' /* webpackChunkName: 'intl-displaynames-locale-data-fi' */
      );
    case 'cs':
      return import(
        '@formatjs/intl-displaynames/locale-data/cs' /* webpackChunkName: 'intl-displaynames-locale-data-cs' */
      );
    case 'bg':
      return import(
        '@formatjs/intl-displaynames/locale-data/bg' /* webpackChunkName: 'intl-displaynames-locale-data-bg' */
      );
    case 'ca':
      return import(
        '@formatjs/intl-displaynames/locale-data/ca' /* webpackChunkName: 'intl-displaynames-locale-data-ca' */
      );
    case 'hr':
      return import(
        '@formatjs/intl-displaynames/locale-data/hr' /* webpackChunkName: 'intl-displaynames-locale-data-hr' */
      );
    case 'et':
      return import(
        '@formatjs/intl-displaynames/locale-data/et' /* webpackChunkName: 'intl-displaynames-locale-data-et' */
      );
    case 'el':
      return import(
        '@formatjs/intl-displaynames/locale-data/el' /* webpackChunkName: 'intl-displaynames-locale-data-el' */
      );
    case 'hu':
      return import(
        '@formatjs/intl-displaynames/locale-data/hu' /* webpackChunkName: 'intl-displaynames-locale-data-hu' */
      );
    case 'lv':
      return import(
        '@formatjs/intl-displaynames/locale-data/lv' /* webpackChunkName: 'intl-displaynames-locale-data-lv' */
      );
    case 'lt':
      return import(
        '@formatjs/intl-displaynames/locale-data/lt' /* webpackChunkName: 'intl-displaynames-locale-data-lt' */
      );
    case 'ro':
      return import(
        '@formatjs/intl-displaynames/locale-data/ro' /* webpackChunkName: 'intl-displaynames-locale-data-ro' */
      );
    case 'sr':
      return import(
        '@formatjs/intl-displaynames/locale-data/sr' /* webpackChunkName: 'intl-displaynames-locale-data-sr' */
      );
    case 'sk':
      return import(
        '@formatjs/intl-displaynames/locale-data/sk' /* webpackChunkName: 'intl-displaynames-locale-data-sk' */
      );
    case 'sl':
      return import(
        '@formatjs/intl-displaynames/locale-data/sl' /* webpackChunkName: 'intl-displaynames-locale-data-sl' */
      );
    case 'sw':
      return import(
        '@formatjs/intl-displaynames/locale-data/sw' /* webpackChunkName: 'intl-displaynames-locale-data-sw' */
      );
    case 'is':
      return import(
        '@formatjs/intl-displaynames/locale-data/is' /* webpackChunkName: 'intl-displaynames-locale-data-is' */
      );
    case 'fil':
      return import(
        '@formatjs/intl-displaynames/locale-data/fil' /* webpackChunkName: 'intl-displaynames-locale-data-fil' */
      );
    case 'ar':
      return import(
        '@formatjs/intl-displaynames/locale-data/ar' /* webpackChunkName: 'intl-displaynames-locale-data-ar' */
      );
    case 'he':
      return import(
        '@formatjs/intl-displaynames/locale-data/he' /* webpackChunkName: 'intl-displaynames-locale-data-he' */
      );
    case 'mt':
      return import(
        '@formatjs/intl-displaynames/locale-data/mt' /* webpackChunkName: 'intl-displaynames-locale-data-mt' */
      );
    case 'az':
      return import(
        '@formatjs/intl-displaynames/locale-data/az' /* webpackChunkName: 'intl-displaynames-locale-data-az' */
      );
    case 'ka':
      return import(
        '@formatjs/intl-displaynames/locale-data/ka' /* webpackChunkName: 'intl-displaynames-locale-data-ka' */
      );
    case 'gl':
      return import(
        '@formatjs/intl-displaynames/locale-data/gl' /* webpackChunkName: 'intl-displaynames-locale-data-gl' */
      );
    case 'eu':
      return import(
        '@formatjs/intl-displaynames/locale-data/eu' /* webpackChunkName: 'intl-displaynames-locale-data-eu' */
      );
    case 'fr-ca':
      return import(
        '@formatjs/intl-displaynames/locale-data/fr-CA' /* webpackChunkName: 'intl-displaynames-locale-data-fr-CA' */
      );
    case 'zh-hant':
      return import(
        '@formatjs/intl-displaynames/locale-data/zh-Hant' /* webpackChunkName: 'intl-displaynames-locale-data-zh-Hant' */
      );
    case 'zh-hans':
      return import(
        '@formatjs/intl-displaynames/locale-data/zh-Hans' /* webpackChunkName: 'intl-displaynames-locale-data-zh-Hans' */
      );
    case 'no':
      // Norwegian bokmål (nb) is the dominant language in Norway
      return import(
        '@formatjs/intl-displaynames/locale-data/nb' /* webpackChunkName: 'intl-displaynames-locale-data-nb' */
      );
    default:
      return import(
        '@formatjs/intl-displaynames/locale-data/en' /* webpackChunkName: 'intl-displaynames-locale-data-en' */
      );
  }
}
